import HttpFactory from '@/mixins/http.factory';
export default {
	name:'authenticate',
	mixins:[HttpFactory],
	data () {
		return {
			data:null,
			isFormValidated:false,
			disableValidateBtn:true,
			auth:{}
		}
	},
	created(){
		this.init();
	},
	methods:{
		init(){
			let _self=this;
			_self.loading=true;
			modalClient = ZAFClient.init();
			parentClient=null;
			modalClient.on('send_data_to_modal', (data) => {
				parentClient = modalClient.instance(data.parentClientGuid)
				_self.zendeskInfo=data;
                _self.auth.userId=_self.zendeskInfo.userInfo?_self.zendeskInfo.userInfo.id:null;
				_self.auth.hdLoginUrl=_self.zendeskInfo.credentials.hdLoginUrl;
				_self.auth.hdEmail=_self.zendeskInfo.user.email;
                _self.auth.jiraUser=_self.zendeskInfo.userInfo.jiraUser;
                
                if(_self.$route.params.jiraUrl){
                    _self.auth.jiraUrl=decodeURIComponent(_self.$route.params.jiraUrl);
                    _self.auth.userId=_self.$route.params.userId;
                }
				_self.loading=false;
			});
		},
		//auth only
		checkForm: function (e,installBtnClick) {
            let _self=this;
            if(!installBtnClick){
                _self.disableValidateBtn=true;
                _self.isFormValidated=false;
            }
            
            _self.userMsg.list = [];
            _self.userMsg.type='danger';
            if (_self.auth.hdLoginUrl && _self.auth.hdToken
            && _self.auth.jiraUrl && _self.auth.jiraToken) {
                return true;
            }
            return;
            if (!_self.auth.hdLoginUrl) {
                _self.userMsg.list.push('Zendesk Url is required.');
            } else if(!_self.validUrl(_self.auth.hdLoginUrl)){
                _self.userMsg.list.push('Zendesk Url is invalid.');
            }
            if (!_self.auth.hdToken) {
                _self.userMsg.list.push('Zendesk Token is  required.');
            }
			if (!_self.auth.hdEmail) {
                _self.userMsg.list.push('Zendesk Email is  required.');
            } else if(!_self.validEmail(_self.auth.hdEmail)){
				_self.userMsg.list.push('Zendesk Email is  invalid.');
			}
            if (!_self.auth.jiraUrl) {
                _self.userMsg.list.push('Atlassian Jira Url is  required.');
            }else if(!_self.validUrl(_self.auth.jiraUrl)){
                _self.userMsg.list.push('Atlassian Jira Url is invalid.');
            }
            if (!_self.auth.jiraToken) {
                _self.userMsg.list.push('Atlassian Jira Token is required.');
            }
            if(e){
                e.preventDefault();
            }
        },
        authenticate(e,cb){
            let _self=this;
            //if(!_self.checkForm(e)) return;
            _self.loading=true;
			_self.auth.appId=_self.zendeskInfo.credentials.appId;
			_self.auth.installationId=_self.zendeskInfo.credentials.installationId; 
            _self.auth.user=_self.zendeskInfo.user;
            var options = {
                method: 'POST',
                body: _self.auth,
                json: true,
                //url: _self.baseUrl+'authenticate',
				url:'authenticate',
                headers: {'Content-Type': 'application/json'}
            }; 
            _self.userMsg.type='danger';
            _self.userMsg.list=[];
            _self.isFormValidated=false;
            _self.post(options.url,options.body).then(function(response) {
                _self.loading=false;
                if(cb) cb(null,response);
                if(response.data.Data && response.data.Success){
                    _self.userMsg.type='info';
                    _self.isFormValidated=true;
                    _self.userMsg.list.push('App validated successfully.');
                    //_self.init();
					_self.sendDataToParent(response.data);
                }else{
                    _self.userMsg.list.push('App validation failed.');
                    if(response && response.data && response.data.Errors && response.data.Errors.length>0){
                        for(var i=0;i<response.data.Errors.length;i++){
                            _self.userMsg.list.push(response.data.Errors[i].Message);
                        }
                    }
                }
            },function(error){
                _self.loading=false;
                _self.userMsg.list.push('App validation failed.');
                if(error && error.response && error.response.Errors && error.response.Errors.length>0){
                    for(var i=0;i<error.response.Errors.length;i++){
                        _self.userMsg.list.push(error.response.Errors[i].Message);
                    }
                }
                if(cb) cb(error);
            });
        },
		validateEmpty:function(txt) {
            if (!txt || txt.trim() === '') {
                return false;
            } else {
                return true;
            }
        },
        validUrl: function (value) {
            return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value);
        },
        validEmail: function (email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
		//auth ends
		closeDialog(){
			modalClient.invoke('destroy');
		},
		sendDataToParent(data){
			parentClient.trigger('receive_data_from_modal', data)
      		modalClient.invoke('destroy');
		},
	}
}

